export default __webpack_public_path__ + "static/media/productslide-4.0c7bacfc.jpg";